export default [
  {
    key: 'id',
    title: '媒体编号',
    width: 46
  },
  {
    key: 'mediaName',
    title: '媒体名称',
    width: 180
  },
  {
    key: 'imeiType',
    title: 'IMEI转换格式'
  },
  {
    key: 'oaidType',
    title: 'OAID转化格式'
  },
  {
    key: 'idfaType',
    title: 'IDFA转换格式'
  },
  {
    key: 'minNum',
    title: '最低数量限制'
  },
  {
    key: 'maxNum',
    title: '最高数量限制'
  },
  {
    key: 'maxCapacity',
    title: '包体最大限制(M)'
  },
  {
    key: 'docType',
    title: '支持格式'
  },
  {
    key: 'transform',
    title: 'MD5格式'
  },
  {
    key: 'updateTime',
    title: '更新时间',
    width: 104
  },
  {
    key: 'control',
    title: '操作',
    width: 150
  }
]
